import { DialogContent as MuiDialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: "20px",
  minHeight: "180px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));
